import { useId } from "react";

import { cn } from "@/lib/utils";

export function MortyLogoIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-[35px] w-[110px] text-white", className)}
      viewBox="0 0 110 35"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.154.001H.293A.269.269 0 000 .248a.273.273 0 00.239.3l14.633 3.17c.251.053.43.284.424.548v26.221a.544.544 0 01-.424.548L.24 34.188a.273.273 0 00-.239.3.269.269 0 00.292.247h18.861c.293 0 .53-.245.53-.547V.548a.539.539 0 00-.53-.547z"
        fill={`url(#${id})`}
      />
      <ellipse
        cx="12.158"
        cy="18.526"
        fill="currentColor"
        rx="0.579"
        ry="1.158"
      />
      <path
        d="M45.957 14.475l-4.674 8.2h-.38L36.23 14.29h-.076v12.34H32.42V8.106h4.2l4.464 8.681h.052l3.266-6.429a4.082 4.082 0 013.634-2.252h1.752v18.527h-3.727V14.475h-.105z"
        fill="currentColor"
      />
      <path
        clipRule="evenodd"
        d="M59.056 12.737c-4.32 0-6.95 2.65-6.95 6.948 0 4.297 2.63 6.947 6.95 6.947 4.319 0 6.944-2.65 6.944-6.947 0-4.298-2.625-6.948-6.944-6.948zm2.84 5.894v2.108c0 1.959-1.07 3.065-2.841 3.065-1.772 0-2.848-1.106-2.848-3.065V18.63c0-1.953 1.082-3.06 2.848-3.06 1.766 0 2.841 1.107 2.841 3.06z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        d="M70.266 23.51v-7.68h-3.109v-3.092h6.97v3.61h.181c.585-1.805 1.853-3.61 4.306-3.61h1.28v3.651h-2.869c-1.723 0-2.921.782-2.921 2.34v4.812h4.434v3.092h-11.38V23.54l3.108-.03zm14.428-.836v-6.131h-3.641v-3.607h2.365c1.166 0 1.59-.398 1.59-1.616V8.105h3.538v4.831h5.243v3.054h-5.243v7.588h5.243v3.054h-4.97c-2.796 0-4.125-1.646-4.125-3.958zM110 12.737l-6.285 14.957-.228.545c-.804 1.94-2.063 3.024-4.42 3.024H96.34v-2.966h2.308c.648 0 1.05-.21 1.248-.62a1.04 1.04 0 00.096-.261l.528-1.397-.45-1.072-5.122-12.204h4.258l2.009 5.615 1.26 3.883h.209l1.2-3.883 2.063-5.615 4.054-.006z"
        fill="currentColor"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id}
          x1="19.694"
          x2="19.694"
          y1="34.724"
          y2="0.001"
        >
          <stop stopColor="#90278e" />
          <stop offset="1" stopColor="#ec297b" />
        </linearGradient>
      </defs>
    </svg>
  );
}
